module.exports = "/static/fonts/OpenSans-Italic.eot";